export default __webpack_public_path__ + "static/media/gift-card.35eac38b.png";